import { queryCache, useQuery } from "react-query"

import { MediaType } from "routes/Base/Admin/GlobalMediaTypes/types"
import { Paginated } from "api/types"
import { fetchMediaConfig } from "api/media-types"
import { useParams } from "react-router-dom"

const targetSemantics = ["targetA", "targetB"]

export function useTargetFieldIds() {
  const { id } = useParams<{ id: string }>()

  const ps = new URLSearchParams([
    ["configScope", "MEDIA_PLAN"],
    ["configOwnerId", id],
  ])
  const cached = queryCache.getQueryData<Paginated<MediaType>>([
    "media-types",
    ps.toString(),
  ])
  const { data: mediaTypes } = useQuery(
    ["media-types", ps.toString()],
    fetchMediaConfig,
    {
      enabled: !cached,
      refetchOnMount: !cached,
      initialData: cached,
    },
  )

  const getTargetIds = (mediaId?: string) => {
    const result: Record<string, string> = {}
    targetSemantics.forEach((ts) => {
      const id = mediaTypes?.data
        ?.find((mt) => mt.id === mediaId)
        ?.mediaFields?.find((mf) => mf.semanticCode === ts)?.id

      if (!!id) result[ts] = id
    })

    return result
  }

  return getTargetIds
}
